export default __webpack_public_path__ + "static/media/step2.abc0e831.png";